import { Box, Flex, Heading, Stack } from "@chakra-ui/react"
import { useRecoilValue, useRecoilState } from "recoil"
import { Routes } from "../../../../constants"
import useReducedLandscapeView from "../../../../hooks/useLandscapeViews"
import { roomSelector } from "../../../../recoil/atoms/room"
import layoutStates from "../../../../recoil/atoms/layout"
import { Logo } from "../../../header/logo"
import { useTranslation } from "react-i18next"
import { isMobileDevice } from "../../../../util/browser"
import useWindowSize from "../../../../hooks/useWindowSize"
import { useBrowserType } from "../../../../hooks/useBrowserType"
import { sessionEndPageAtom } from "../../../../recoil/atoms/sessionModalData"
import { useHistory, useLocation } from "react-router"
import HomeBackIcon from "../../home/HomeBackIcon"
import useSearchParams from "src/hooks/useSearchParams"
import { mobilePurchaseJustCompletedAtom } from "src/recoil/atoms/plans"
import { useLocalStorage } from "src/hooks/useLocalStorage"
import React from "react"
import usePageStyling from "src/hooks/usePageStyling"
import UIGridHeader from "../../avatars/components/UIGridHeader"
import { SafeArea } from "src/components/common/SafeArea"
import useConfig from "src/hooks/useConfig"
import { BlobBackground } from "src/components/common/BlobBackground"

export const PlansLayout = ({ children }) => {
  const { t } = useTranslation()
  const config = useConfig()
  const { screenSize } = useWindowSize()
  const { isSafariMobile, isAndroid } = useBrowserType()
  const isMobile = isSafariMobile || isAndroid
  const isLandscape = screenSize.width > screenSize.height
  const params = useSearchParams<{
    success?: true | undefined
    canceled?: true | undefined
  }>()

  const cameFromCheckoutSuccess: boolean = params.success
  const cameFromCheckoutCancel: boolean = params.canceled
  const [_, __, ___, clearReturnToHash] = useLocalStorage("returnToHash")

  const plansPageStyles = usePageStyling("plansPageStyling")
  const [mobilePurchaseJustCompleted, setMobilePurchaseJustCompleted] =
    useRecoilState(mobilePurchaseJustCompletedAtom)
  const room = useRecoilValue(roomSelector)
  const showMinifiedLables = useReducedLandscapeView()

  const sessionEndPage = useRecoilValue(sessionEndPageAtom)

  const history = useHistory()
  const location = useLocation()
  const urlParams = new URLSearchParams(location.search)
  const shouldGoBack = urlParams.get("go_back")

  return (
    <Box position="relative" width="100%" height="100%">
      <BlobBackground
        background={
          plansPageStyles?.planPageBackgroundColor
            ? plansPageStyles.planPageBackgroundColor
            : "gray.100"
        }
      />
      <SafeArea position="absolute">
        <Flex
          justify={"center"}
          bgSize="cover"
          backgroundPosition="center"
          bgRepeat="no-repeat"
          left="0"
          w="100%"
          h="100%"
        >
          <Box height="100%" width="100%" display="flex" flexDir="column">
            <UIGridHeader
              headerTitle="Subscriptions"
              showBackButton
              customBackAction={() => {
                clearReturnToHash()
                setMobilePurchaseJustCompleted(false)
                history.replace(config.postLoginRedirectUrl)
              }}
            />
            <Stack
              overflowY={"auto"}
              spacing={isMobileDevice(screenSize) && 4}
              mx={"auto"}
              // maxW={"lg"}
              // py={isMobileDevice(screenSize) && 12}
              // px={isMobileDevice(screenSize) && 6}
              // width={
              //   isMobileDevice(screenSize) && !(isMobile && isLandscape) && "100%"
              // }
              alignItems="center"
            >
              <Box
                rounded={"lg"}
                bg={
                  plansPageStyles?.planPagePanelBackgroundColor
                    ? plansPageStyles?.planPagePanelBackgroundColor
                    : "#FFFFFF"
                }
                boxShadow={"lg"}
                p={4}
                // px={16}
                // maxWidth={isMobileDevice(screenSize) ? "400px" : "fit-content"}
                // width={"100%"}
                borderWidth="1px"
                borderColor={
                  plansPageStyles?.planPagePanelBorderColor
                    ? plansPageStyles?.planPagePanelBorderColor
                    : "transparent"
                }
              >
                <Stack spacing={"0.4rem"}>{children}</Stack>
              </Box>
            </Stack>
          </Box>
        </Flex>
      </SafeArea>
    </Box>
  )
}
